import React from 'react';
import { AuthLoading as Loading } from 'venn-components';
import type { NamedEntityInteger } from 'venn-api';
import { resolveHelpCenterPlaceholders } from 'venn-ui-kit';
import { TermsLayout as Layout } from './TermsLayout';

interface TermsProps {
  terms: NamedEntityInteger[];
  error: string;
  loading: boolean;
  accept(term: NamedEntityInteger): void;
}

const Terms = ({ accept, terms, error, loading }: TermsProps) => {
  if (error) {
    return <Layout>{error}</Layout>;
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <Layout acceptTerm={() => accept(terms[0]!)} acceptButtonText="Continue" enableLegalLinks>
      {terms[0] ? resolveHelpCenterPlaceholders(terms[0].name) : ''}
    </Layout>
  );
};

export default Terms;
